import React, { useMemo } from "react";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useProjectFilePlanContext from "../context/use-project-file-plan-context.ts";
import Card from "../../../../../../../components/card";
import Toggle from "../../../../../../../components/toggle/index.tsx";
import ToggleButton from "../../../../../../../components/buttons/button-toggle";

const CardLeft: React.FC = () => {
    const { isOverlayActive, setIsOverlayActive, planFileDataLeft: planFileData, isDrawingLeft: isDrawing, setIsDrawingLeft: setIsDrawing, dispatchLeft: dispatch } = useProjectFilePlanContext();

    const sortedOrigins = useMemo(() => {
        if (!planFileData.origins) return [];

        return [...planFileData.origins].sort((a, b) => a.name.localeCompare(b.name, "fr", { sensitivity: "base" }));
    }, [planFileData.origins]);

    return (
            <div className='absolute top-4 left-4 z-2'>
                <Card additionalClasses='select-none w-102'>
                    <div className='flex flex-col gap-y-3 px-4 py-2'>
                        <div className='grid grid-cols gap-2 items-center'>
                            <Toggle toggled={isOverlayActive} onToggledChange={(enabled) => {
                                setIsOverlayActive(enabled);

                                if (!enabled && planFileData.origins.length !== 0) {
                                    dispatch({
                                        type: "reset-origin"
                                    });
                                }
                            }} label="Superposez votre plan par rapport à un autre plan" description="" />
                        </div>

                        {isOverlayActive &&
                            <div className='grid grid-cols items-center'>
                                <div className='self-start pt-1 text-sm'>Créez une origine</div>
                                <div className="flex flex-col gap-2 border-1 p-2 border-gray-300 text-sm">
                                    {sortedOrigins.map(o =>
                                        <label key={o.id} className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="origin-left"
                                                value={o.id}
                                                checked={o.isActive}
                                                onChange={() => {
                                                    dispatch({
                                                        type: "change-origin",
                                                        origin: o
                                                    });
                                                }}
                                            />
                                            <span style={{color: o.color}}>{o.name}</span>

                                            {/* <Button variant='ghost' size='sm' disabled={o.isActive} onClick={() => dispatch({
                                                type: "delete-origin",
                                                originId: o.id
                                            })}>
                                                 <FontAwesomeIcon icon={faTrash} className='text-red-500' />
                                            </Button> */}
                                        </label>
                                    )}
                                    <ToggleButton className='mr-auto' variant='ghost' size='sm' toggled={isDrawing} setIsToggled={setIsDrawing} disabled={isDrawing}>
                                        <FontAwesomeIcon icon={faPlus} className="text-green-500" />
                                    </ToggleButton>
                                </div>
                            </div>
                        }
                    </div>
                </Card>
            </div>
    )
}

export default CardLeft;